import * as types from '../actions/types';

const initialState = {
    retailerSearchdata:[]
}

export default function retailerSearchcriteriaReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.RETAILER_SEARCH_CRITERIA:
            return {
               
                retailerSearchdata:action.payload,
            } 
        default:
            return state
    }
}
